import { HTMLAttributes, ReactNode } from 'react';

import { styled } from 'styled-components';

import { t } from 'translations';
import { Background } from 'ui/styles/layout';
import { Text } from 'ui/styles/text';

const Container = styled.div(
  ({ theme }) => `
  padding: ${theme.margin};
`,
);

const Hr = styled.hr(
  ({ theme }) => `
  margin: ${theme.margin} 0;
  border: 1px solid ${theme.colors.grayMedium};
`,
);

const List = styled.ul(
  ({ theme }) => `
  padding: 0;
  margin: 0;

  li {
    margin: ${theme.margin} 0;
  }
`,
);

const Row = styled.li`
  display: flex;
  justify-content: space-between;
  gap: 10px;
`;

interface SummaryRowProps {
  label: ReactNode;
  value?: ReactNode;
  note?: ReactNode;
}

export const SummaryRow = ({ label, value, note }: SummaryRowProps) => {
  return (
    <Row>
      <Text as="p">{label}</Text>
      <div>
        {value && (
          <Text as="p" $textAlign="right">
            {value}
          </Text>
        )}
        {note && (
          <Text as="p" $textAlign="right" $fontSize="xsmall" $color="grayLight">
            {note}
          </Text>
        )}
      </div>
    </Row>
  );
};

export const MembershipSummary = ({ children, ...props }: HTMLAttributes<HTMLDivElement>) => {
  return (
    <Background {...props}>
      <Container>
        <Text as="h2">{t('membership_hub_signup_membership_summary_title')}</Text>
        <Hr />
        <List>{children}</List>
      </Container>
    </Background>
  );
};
